<template>
    <FilePickerField
        :model-value="itemvalue || ''"
        :format-data="formatData"
        :label="inputLabel"
        :hint="hintText"
        :rules="rules"
        :compiler-error-field-props="compilerErrorFieldProps"
        :show-bottom-slots="showFieldBottomSlots"
        @update:model-value="sync"
        @focus="onFocus"
        @blur="onBlur"
    />
</template>

<script>
    import BaseComponent from './baseFormMixin.jsx';
    import FilePickerField from './filePickerField.vue';

    export default {
        name: 'sform-filepicker',
        mixins: [BaseComponent],
        components: {
            FilePickerField,
        },
        mounted() {
            this.loadComplete();
        },
        computed: {
            formatData() {
                return this.element?.formatData
                    || this.element?.schema?.formatData
                    || {};
            },
        },
    };
</script>
